// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__37kVk","title":"ClientReferral_title__1MK5Y","itemText":"ClientReferral_itemText__32mFl"};